import React from "react";
import { Row, Col, Form, FormGroup, Label, Input, Card, CardBody } from "reactstrap";
import { DomainSettingsValues, SettingsProps } from "../../types/settings";
import SettingsButtons from "./SettingsButtons";
import { Formik } from "formik";
import { domainSettingsValidation } from "rules/settings";

const DomainSettings: React.FC<SettingsProps> = ({ 
  onGlobalCancel, 
  isSaving, 
  onSave 
}) => {
  const initialValues: DomainSettingsValues = {
    primaryDomain: "",
    forceSSL: false,
    autoRedirect: false,
    domainAliases: ""
  };

  const handleSave = async (values: DomainSettingsValues) => {
    await onSave(async () => {
      console.log("Form submitted with values:", values);
      await new Promise(resolve => setTimeout(resolve, 1000));
      // TODO: Add actual API call here
    });
  };

  return (
    <div className="bg-transparent">
      <h5 className="mb-4">Domain Settings</h5>
      <Formik
        initialValues={initialValues}
        validationSchema={domainSettingsValidation}
        onSubmit={handleSave}
        validateOnMount={true}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <Form>
            <Card className="mb-4">
              <CardBody>
                <h6 className="mb-3">Primary Domain</h6>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="primaryDomain">Primary Domain Name</Label>
                      <Input
                        type="text"
                        id="primaryDomain"
                        name="primaryDomain"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.primaryDomain}
                        placeholder="Enter your primary domain"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <hr className="my-4" />

                <h6 className="mb-3">SSL Configuration</h6>
                <Row>
                  <Col md={6}>
                    <FormGroup check className="mb-3">
                      <Input 
                        type="checkbox" 
                        id="forceSSL"
                        name="forceSSL"
                        onChange={handleChange}
                        checked={values.forceSSL}
                      />
                      <Label check for="forceSSL">
                        Force SSL/HTTPS
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup check className="mb-3">
                      <Input 
                        type="checkbox" 
                        id="autoRedirect"
                        name="autoRedirect"
                        onChange={handleChange}
                        checked={values.autoRedirect}
                      />
                      <Label check for="autoRedirect">
                        Auto-redirect to HTTPS
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>

                <hr className="my-4" />

                <h6 className="mb-3">Domain Aliases</h6>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="domainAliases">Additional Domains</Label>
                      <Input
                        type="textarea"
                        id="domainAliases"
                        name="domainAliases"
                        rows={3}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.domainAliases}
                        placeholder="Enter additional domains (one per line)"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <SettingsButtons
              onSave={handleSubmit}
              onCancel={onGlobalCancel}
              saveDisabled={Object.keys(errors).length > 0}
              isSaving={isSaving}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default DomainSettings;
